"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gameReducer = gameReducer;
var _types = require("./types");
var _GameStatus = require("../enums/GameStatus");
var _RoundState = require("../enums/RoundState");
var _types2 = require("../com/types");
var _ReelState = require("../enums/ReelState");
var _FeatureAwardType = require("../enums/FeatureAwardType");
var _types3 = require("../blitz/types");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialState = {
  roundState: _RoundState.RoundState.Ended,
  gameStatus: _GameStatus.GameStatus.Initiating,
  freeSpinsAwarded: 0,
  freeSpinsLeft: 0,
  freeSpinsPlayed: 0,
  keepingAlive: false,
  reelState: _ReelState.ReelState.Stopped,
  reelControl: _types.ReelControlState.Stopped,
  spinPaylineWins: [],
  featureFreeSpins: false,
  featureReSpin: false,
  featureFreeSpinsTriggerCount: 0,
  featureReSpinTriggerCount: 0,
  featureCoinsWon: 0,
  totalSpinLineWinCoins: 0,
  exited: false
};
function gameReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.GAME_FEATURE_START:
      {
        // add winning from feature to counter.
        var newState = Object.assign({}, state);
        newState.featureCoinsWon = action.payload.coinsWon;
        switch (action.payload.type) {
          case _FeatureAwardType.FeatureAwardType.FreeSpins:
            {
              newState.featureFreeSpinsTriggerCount++;
              newState.featureFreeSpins = true;
              break;
            }
          case _FeatureAwardType.FeatureAwardType.Respin:
            {
              newState.featureReSpinTriggerCount++;
              newState.featureReSpin = true;
              break;
            }
        }
        return newState;
      }
    case _types.FREE_SPINS_WON:
      {
        return Object.assign({}, state, {
          freeSpinsAwarded: state.freeSpinsAwarded + action.payload,
          freeSpinsLeft: state.freeSpinsLeft + action.payload
        });
      }
    case _types.FREE_SPIN_SPINNING:
      {
        return Object.assign({}, state, {
          freeSpinsPlayed: state.freeSpinsPlayed + 1
        });
      }
    case _types.FREE_SPIN_PLAYED:
      {
        return Object.assign({}, state, {
          freeSpinsLeft: state.freeSpinsLeft - 1
        });
      }
    case _types.RESPIN_PLAYED:
      {
        // add winning from feature to counter.
        var _newState = Object.assign({}, state, {});
        _newState.featureReSpinTriggerCount--;
        if (_newState.featureReSpinTriggerCount == 0) _newState.featureReSpin = false;
        return _newState;
      }
    case _types.GAME_FEATURE_END:
      {
        // add winning from feature to counter.
        var _newState2 = Object.assign({}, state, {});
        switch (action.payload.type) {
          case _FeatureAwardType.FeatureAwardType.FreeSpins:
            {
              _newState2.featureFreeSpinsTriggerCount--;
              if (_newState2.featureFreeSpinsTriggerCount == 0) _newState2.featureFreeSpins = false;
              break;
            }
        }
        return _newState2;
      }
    case _types.REELS_SPIN:
      {
        return Object.assign({}, state, {
          reelControl: _types.ReelControlState.Starting,
          started: new Date(),
          totalSpinLineWinCoins: 0,
          quickStop: false,
          presentationStop: false,
          spinPaylineWins: []
        });
      }
    case _types.PRESENTATION_STOP_AVAILABLE:
      {
        if (state.roundState == _RoundState.RoundState.Started) return Object.assign({}, state, {
          presentationStopAvailable: true
        });
      }
    case _types.PRESENTATION_STOP_RESET:
      {
        if (state.roundState == _RoundState.RoundState.Started) return Object.assign({}, state, {
          presentationStopAvailable: false
        });
      }
    case _types.REELS_SPINNING:
      {
        return Object.assign({}, state, {
          reelControl: _types.ReelControlState.Spinning,
          quickStop: false
        });
      }
    case _types.SLOW_SERVER_RESPONSE:
      {
        return Object.assign({}, state, {
          slowServerResponse: true
        });
      }
    case _types.SET_REELS:
      {
        return Object.assign({}, state, {
          slowServerResponse: false,
          reels: action.payload
        });
      }
    case _types.REELS_STOPPING:
      {
        return Object.assign({}, state, {
          reelControl: _types.ReelControlState.Stopping
        });
      }
    case _types.REELS_STOPPED:
      {
        return Object.assign({}, state, {
          reelControl: _types.ReelControlState.Stopped,
          started: undefined,
          reconnectSpin: false
        });
      }
    case _types.REELS_STATE_SPINNING:
      {
        return Object.assign({}, state, {
          reelState: _ReelState.ReelState.Spinning
        });
      }
    case _types.REELS_STATE_STOPPED:
      {
        return Object.assign({}, state, {
          reelState: _ReelState.ReelState.Stopped,
          quickStopAvailable: false
        });
      }
    case _types3.BLITZ_MODE_ON:
      {
        return Object.assign({}, state, {
          winCounter: 0
        });
      }
    case _types.ROUND_START:
      {
        var _newState3 = Object.assign({}, state, {
          gameStatus: _GameStatus.GameStatus.Running,
          roundState: _RoundState.RoundState.Started,
          roundResultPending: true,
          started: new Date(),
          totalWin: 0,
          winCounter: 0,
          freeSpinsAwarded: 0,
          freeSpinsLeft: 0,
          freeSpinsPlayed: 0,
          presentationStop: false
        });
        return _newState3;
      }
    case _types.ROUND_END:
      {
        return Object.assign({}, state, {
          roundState: _RoundState.RoundState.Ended,
          totalWin: action.payload.totalCoinsWon,
          spinStopIn: null,
          quickStop: false,
          featureFreeSpins: false,
          featureReSpin: false,
          featureFreeSpinsTriggerCount: 0,
          featureReSpinTriggerCount: 0,
          featureCoinsWon: 0,
          freeSpinsAwarded: 0,
          freeSpinsLeft: 0,
          //      freeSpinsPlayed: 0, THIS MIGHT BE BAD NEED TO TEST OTHER GAMES
          reconnect: false,
          quickStopAvailable: false,
          presentationStopAvailable: false
        });
      }
    case _types.ROUND_VOID:
      {
        return Object.assign({}, state, {
          roundState: _RoundState.RoundState.Ended
        });
      }
    case _types.TOTAL_WIN_FORMATED:
      {
        return Object.assign({}, state, {
          totalWinFormatted: action.payload
        });
      }
    case _types.GAME_WINCOUNTER_SET:
      {
        var _newState4 = Object.assign({}, state, {
          winCounter: action.payload
        });
        return _newState4;
      }
    case _types.GAME_WINCOUNTER_ADD:
      {
        var _newState5 = Object.assign({}, state, {
          winCounter: state.winCounter + action.payload
        });
        return _newState5;
      }
    case _types.GAME_COUNT_FEATURE_AS_LINE:
      {
        var _newState6 = Object.assign({}, state, {
          totalSpinLineWinCoins: state.totalSpinLineWinCoins + action.payload
        });
        return _newState6;
      }
    case _types.PAYLINE_WIN:
      {
        var _newState7 = Object.assign({}, state, {
          spinPaylineWins: [].concat(_toConsumableArray(state.spinPaylineWins), [action.payload]),
          totalSpinLineWinCoins: state.totalSpinLineWinCoins + action.payload.coinsWon
        });
        return _newState7;
      }
    case _types.GAME_READY:
      {
        return Object.assign({}, state, {
          gameStatus: _GameStatus.GameStatus.Idle,
          gameReady: true
        });
      }
    case _types2.CONNECTED:
      {
        if (state.gameStatus == _GameStatus.GameStatus.Disconnected) {
          return Object.assign({}, state, {
            gameStatus: _GameStatus.GameStatus.Idle
          });
        } else return state;
      }
    case _types.GAME_STATUS_SET:
      {
        return Object.assign({}, state, {
          gameStatus: action.payload
        });
      }
    case _types2.SESSION_EXPIRED:
      {
        return Object.assign({}, state, {
          sessionExpired: true
        });
      }
    case _types.QUICK_STOP_AVAILABLE:
      {
        return Object.assign({}, state, {
          quickStopAvailable: true
        });
      }
    case _types.QUICK_STOP:
      {
        return Object.assign({}, state, {
          quickStop: true,
          quickStopAvailable: false
        });
      }
    case _types.PRESENTATION_STOP_AVAILABLE:
      {
        return Object.assign({}, state, {
          presentationStopAvailable: true
        });
      }
    case _types.PRESENTATION_STOP:
      {
        return Object.assign({}, state, {
          presentationStop: true,
          presentationStopAvailable: false
        });
      }
    case _types.IDLE:
      {
        return Object.assign({}, state, {
          gameStatus: _GameStatus.GameStatus.Idle
        });
      }
    case _types.SET_SPIN_STOP_WAIT:
      {
        return Object.assign({}, state, {
          spinStopIn: action.payload.ms
        });
      }
    case _types.KEEP_ALIVE_STARTED:
      {
        return Object.assign({}, state, {
          keepingAlive: true
        });
      }
    case _types.KEEP_ALIVE_STOP:
      {
        return Object.assign({}, state, {
          keepingAlive: false
        });
      }
    case _types.EXITING:
      {
        return Object.assign({}, state, {
          exited: true
        });
      }
    case _types.HYPER_SPIN_START:
      {
        return Object.assign({}, state, {
          hyperSpin: true
        });
      }
    case _types.HYPER_SPIN_STOP:
      {
        return Object.assign({}, state, {
          hyperSpin: false
        });
      }
    case _types.GAME_PLAYER_INPUT_WAIT:
      {
        return Object.assign({}, state, {
          gameStatus: _GameStatus.GameStatus.PlayerInput
        });
      }
    case _types.GAME_PLAYER_INPUT:
      {
        return Object.assign({}, state, {
          /// not sure about this, might need to be different ones.
          gameStatus: _GameStatus.GameStatus.Running
        });
      }
    case _types.UNFINISHED_FEATURE:
      {
        var _newState8 = Object.assign({}, state, {});
        _newState8.reconnect = true;
        _newState8.reconnectSpin = true;
        _newState8.winCounter = action.payload.coinsWon;
        _newState8.roundId = action.payload.roundId;
        _newState8.roundResultPending = false;
        switch (action.payload.awardType) {
          case _FeatureAwardType.FeatureAwardType.FreeSpins:
            {
              _newState8.featureFreeSpinsTriggerCount = action.payload.triggerCount;
              _newState8.featureFreeSpins = true;
              _newState8.freeSpinsAwarded = action.payload.freeSpinsWon;
              _newState8.freeSpinsLeft = action.payload.freeSpinsWon - action.payload.freeSpinsPlayed;
              _newState8.freeSpinsPlayed = action.payload.freeSpinsPlayed;
              break;
            }
        }
        return _newState8;
      }
    // so quick stop is available in classic after blitz
    case _types3.BLITZ_FEATURE_WON:
      {
        return Object.assign({}, state, {
          roundResultPending: false
        });
      }
    case _types.SET_ROUND_ID:
      {
        //L.debug('Round ID : ' + action.payload) help with blitz performance.
        return Object.assign({}, state, {
          roundId: action.payload,
          roundResultPending: false
        });
      }
    case _types.COLLECTIONS_UPDATE:
      {
        return Object.assign({}, state, {
          collections: action.payload
        });
      }
    case _types.COLLECTION_UPDATE:
      {
        return Object.assign({}, state, {
          collection: action.payload
        });
      }
    case _types.SERVER_GAME_READY:
      {
        return Object.assign({}, state, {
          serverGameReady: true
        });
      }
    case _types.LOCK:
      {
        return Object.assign({}, state, {
          locked: true
        });
      }
    case _types.UN_LOCK:
      {
        return Object.assign({}, state, {
          locked: false
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map